module.exports = __webpack_public_path__ + "static/media/BrutalType-Bold.0dfc6422.woff2";